<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header" style="paddingRight: 0;padding-bottom: 0">
      <el-form :model="form" class="com-search-box" ref="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="图书名称 :" prop="name">
              <el-input v-model="form.name" placeholder="请输入图书名称"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="图书编号 :" prop="bookNo">
              <el-input v-model="form.bookNo" placeholder="请输入图书编号"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item class="el-form-state1" label="借阅人 :" prop="useName">
              <el-select v-model="form.useName" filterable clearable remote placeholder="请选择借阅人"
                :remote-method="remoteMethod" :loading="loading">
                <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList('form')">重置</el-button>
      </div>

    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row type="flex">
          <el-button @click="addBorrow" class="el-primary-border">
            <svg-icon icon-class="add" />&nbsp;添加借阅
          </el-button>

          <el-button @click="exportBorrowList" class="el-primary-border">
            <svg-icon icon-class="add" />&nbsp;导出
          </el-button>
        </el-row>
      </div>
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="user_name" label="申请借阅人" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="apply_time" label="申请时间" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="receive_time" label="领书时间" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="name" label="借阅书名" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="book_no" label="借阅图书编号" min-width="7%"></el-table-column>
          <el-table-column prop="borrow_num" label="借阅数量" min-width="7%"></el-table-column>
          <el-table-column prop="borrow_day" label="借阅天数" min-width="7%"></el-table-column>
          <el-table-column prop="return_time" label="应归还时间" min-width="7%"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="7%">
            <template slot-scope="scope">{{ scope.row.status | filterStatus(scope.row.deferred_status) }}</template>
          </el-table-column>
          <el-table-column prop="deferred_day" label="延期申请天数" min-width="7%"></el-table-column>

          <el-table-column fixed="right" label="操作" min-width="10%">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">
                <a class="m-btn mr-10" @click="borrowPass(scope.row)">通过</a>
                <a class="m-btn mr-10  m-danger" @click="borrowRefuse(scope.row)">拒绝</a>
              </span>

              <span v-if="scope.row.status == 2">
                <a class="m-btn mr-10" @click="receive(scope.row.id)">领取</a>
              </span>

              <span v-if="scope.row.status == 3">
                <a class="m-btn c-d mr-10" @click="receive(scope.row.id)">-</a>
              </span>

              <span v-if="scope.row.status == 4">
                <a class="m-btn mr-10" @click="returnBook(scope.row.id)">归还</a>
                <!-- <a class="m-btn mr-10" @click="delay(scope.row.id)">延期</a> -->
              </span>

              <span v-if="scope.row.status == 0 ||scope.row.status == 5 || scope.row.status == 6">
                <a class="m-btn mr-10">-</a>
              </span>

              <span v-if="scope.row.status == 7">
                <a class="m-btn mr-10" @click="borrowPass(scope.row)">同意</a>
                <a class="m-btn mr-10  m-danger" @click="borrowRefuse(scope.row)">驳回</a>
              </span>
              <!-- <a class="m-btn mr-10" @click="handleInterView( scope.row.id)">编辑</a> -->
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <el-dialog title="新增借阅记录" :visible.sync="dialogVisible" :close-on-click-modal="false" :before-close="handleClose"
      width="30%">
      <el-form class="g-form-grid" ref="addForm" :model="addForm" label-width="90px" :rules="rules">
        <el-form-item label="借阅人 :" prop="userId">
          <el-select v-model="addForm.userId" filterable remote reserve-keyword placeholder="请选择借阅人"
            :remote-method="remoteMethod" :loading="loading">
            <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图书名称 :" prop="bookId">
          <el-select v-model="addForm.bookId" filterable remote reserve-keyword :remote-method="remoteBookMethod"
            placeholder="请选择" :loading="bookLoading">
            <el-option v-for="item in borrowBookListt" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请时间 :" prop="applyTime">
          <el-date-picker v-model="addForm.applyTime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime" placeholder="请选择"></el-date-picker>
        </el-form-item>

        <el-form-item label="领书时间 :" prop="receiveTime">
          <el-date-picker v-model="addForm.receiveTime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime" placeholder="请选择"></el-date-picker>
        </el-form-item>

        <el-form-item label="借阅天数 :" prop="borrowDay">
          <el-input type='number' v-model="addForm.borrowDay" placeholder="只允许输入数字"></el-input>
        </el-form-item>

        <el-form-item label="借阅数量 :" prop="borrowNum">
          <el-input type='number' v-model="addForm.borrowNum" placeholder="只允许输入数字"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import axios from 'axios'
export default {
  components: {
  },
  computed: {
    userData() {
      return this.$store.state.user
    }
  },
  data() {
    return {
      that: this,
      form: {
        name: '',
        bookNo: '',
        useName: '',
        type: 1
      },
      loading: false,
      bookLoading: false,
      addForm: {
        applyTime: '',
        receiveTime: '',
        userId: '',
        type: 1,
        borrowDay: '',
        borrowNum: '',
        // a8f45e9768c7f8aa4e31a302a5a8fcfc
        bookId: ''
      },
      rules: {
        applyTime: [
          { required: true, message: '申请时间不能为空', trigger: 'blur' },
        ],

        receiveTime: [
          { required: true, message: '领书时间不能为空', trigger: 'blur' },
        ],

        bookId: [
          { required: true, message: '领书名称不能为空', trigger: 'blur' },
        ],

        userId: [
          { required: true, message: '领取人不能为空', trigger: 'blur' },
        ],

        borrowDay: [
          { required: true, message: '借阅天数为空', trigger: 'blur' },
        ],

        borrowNum: [
          { required: true, message: '领取数量不能为空', trigger: 'blur' },
        ],
      },
      userList: [],
      borrowBookListt: [],
      listLoading: true,
      tableData: [],
      listQuery: {
        currentPage: 1,
        size: 10
      },
      dialogVisible: false,
      total: 0,
    }
  },

  filters: {
    filterStatus(status, deferred_status) {
      if (deferred_status != null) {
        if (deferred_status == 0) {
          return '延期申请中'
        } if (deferred_status == 1) {
          return '延期申请通过'
        } if (deferred_status == 2) {
          return '未通过'
        }
      } else {
        switch (status) {
          case 0:
            return '申请已取消'
          case 1:
            return '待审批'
          case 2:
            return '待领书'
          case 3:
            return '已拒绝'
          case 4:
            return '借阅中'
          case 5:
            return '已归还'
          case 6:
            return '已逾期'
          case 7:
            return '延期申请中'
        }
      }
    }
  },

  methods: {
    initData() {
      this.listLoading = true
      this.$api.book.getAdminPageList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        if (res.success) {
          this.tableData = res.result.records
          this.total = res.result.total
        }
        this.listLoading = false
      }).catch(err => {
        this.listLoading = false
      })

    },

    // 下拉框查询借阅人列表
    remoteMethod(query) {
      this.loading = true
      this.getUserInfo({ nameOrPhone: query })
    },

    remoteBookMethod(query) {
      let param = { name: query }
      this.bookLoading = true
      this.getBorrowBookList(param)
    },

    // 新增借阅记录
    addBorrow() {
      this.dialogVisible = true
      this.getBorrowBookList()
    },

    // 获取借阅书籍列表
    getBorrowBookList(param) {
      this.borrowBookListt = []
      this.$api.book.getBookPageList({
        ...param,
        currentPage: 1,
        type: '1,2',
        size: 99999
      }).then(res => {
        this.bookLoading = false
        if (res.success) {
          this.borrowBookListt = res.result.records
        }
      }).catch(err => {
        this.bookLoading = false
      })
    },

    // 导出借阅列表
    exportBorrowList() {
      this.$common.confirm(
        {
          title: `是否导出？`,
          className: 'cus-confirm-375'
        }, () => {
          axios({
            method: 'get',
            url: '/singleMuseum/book/bsBookApproval/export',
            responseType: 'blob', //二进制流
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            params: {
              ...this.form,
              ...this.listQuery
            }
          }).then(res => {
            if (res) {
              let fileName = '';
              const blob = new Blob([res.data]);
              if (res.headers) {
                let contentDisposition = res.headers['content-disposition'];
                if (contentDisposition) {
                  fileName = window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8");
                }
                if (fileName) {
                  fileName = fileName.split('.')[0]
                }
              }
              const linkNode = document.createElement('a');
              linkNode.setAttribute('download', fileName + '.xls');
              linkNode.style.display = 'none';
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click();  //模拟在按钮上的一次鼠标单击

              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
            }
          })
        }
      )
    },

    // 重置
    restList(formName) {
      this.$refs[formName].resetFields()
      this.getUserInfo()
      this.listQuery.currentPage = 1
      this.initData()
    },

    //申请通过
    borrowPass(obj) {
      this.$common.confirm(
        {
          title: `是否通过${obj.user_name}借阅申请？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.borrowPass({
            id: obj.id
          }).then(res => {
            if (res.success) {
              this.$message.success('申请通过')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    //申请拒绝
    borrowRefuse(obj) {
      this.$common.confirm(
        {
          title: `是否拒绝${obj.user_name}借阅申请？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.borrowRefuse({
            id: obj.id
          }).then(res => {
            if (res.success) {
              this.$message.success('申请拒绝')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    //领书
    receive(id) {
      this.$common.confirm(
        {
          title: `是否已领书？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.receive({
            id: id
          }).then(res => {
            if (res.success) {
              this.$message.success('成功领书')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 归还
    returnBook(id) {
      this.$common.confirm(
        {
          title: `是否归还图书？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.returnBook({
            id: id
          }).then(res => {
            if (res.success) {
              this.$message.success('归还成功')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 延迟
    delay(id) {
      this.$common.confirm(
        {
          title: `是否延期归还图书？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.book.delay({
            id: id
          }).then(res => {
            if (res.success) {
              this.$message.success('延期成功')
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initData()
    },

    // 领取人列表
    getUserInfo(param) {
      this.userList = []
      this.$api.book.getUserInfo(param).then(res => {
        this.loading = false
        if (res.success) {
          this.userList = res.result
        }
      })
    },

    //新增
    handleSubmit() {
      // this.addForm.userId = this.userData.userid
      console.log(this.addForm)
      this.$refs['addForm'].validate(vaild => {
        if (vaild) {
          this.$api.book.addAdminRecord({
            ...this.addForm,
          }).then(res => {
            if (res.success) {
              this.$message.success('新增成功')
              this.handleClose()
              this.initData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },

    //取消
    handleClose() {
      this.$refs['addForm'].resetFields()
      this.dialogVisible = false
    },

    getTableList() {
      this.listQuery.currentPage = 1
      this.initData()
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    }
  },

  mounted() {
    this.getUserInfo()
    this.initData()
    window.addEventListener('keyup', this.keydown)
  }
}
</script>

<style lang="scss" scoped>
.com-search-box {
  /deep/ .el-col {
    margin-bottom: 30px;
  }
}

/deep/ .el-date-editor {
  width: 100%;
}

.el-form-state1 {
  /deep/ .el-form-item__label {
    width: 70px !important;
  }

  /deep/ .el-form-item__content {
    margin-left: 70px !important;
  }
}
</style>